import { Button, Card, Col, Form, Input, Row, Select, Space } from "antd"
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons"
import type React from "react"
import type { AiWordSearchParams } from "@/services/log/aiWordApi"

interface AiWordSearchFormProps {
  onSearch: (values: Partial<AiWordSearchParams>) => void
  loading?: boolean
  initialValues?: Partial<AiWordSearchParams>
}

const SORT_OPTIONS = [
  { label: "Lượt tìm kiếm nhiều nhất (Hot)", value: "search_count:DESC" },
  { label: "Lượt tìm kiếm ít nhất", value: "search_count:ASC" },
  { label: "Lượt thêm nhiều nhất", value: "add_count:DESC" },
  { label: "Lượt thêm ít nhất", value: "add_count:ASC" },
  { label: "Mới tạo gần đây nhất", value: "created_at:DESC" },
  { label: "Tạo cũ nhất", value: "created_at:ASC" },
]

export const AiWordSearchForm: React.FC<AiWordSearchFormProps> = ({ onSearch, loading = false, initialValues }) => {
  const [form] = Form.useForm()

  const defaultSortValue =
    initialValues?.sort_by && initialValues?.sort_order
      ? `${initialValues.sort_by}:${initialValues.sort_order}`
      : "search_count:DESC"

  const handleFinish = (values: { search?: string; sort?: string }) => {
    let sort_by = "search_count"
    let sort_order: "ASC" | "DESC" = "DESC"

    if (values.sort) {
      const [by, order] = values.sort.split(":")
      sort_by = by
      sort_order = order as "ASC" | "DESC"
    }

    onSearch({
      search: values.search?.trim() || undefined,
      sort_by,
      sort_order,
    })
  }

  const handleReset = () => {
    form.resetFields()
    onSearch({
      search: undefined,
      sort_by: "search_count",
      sort_order: "DESC",
    })
  }

  return (
    <Card className="mb-2 shadow-xs">
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        initialValues={{
          search: initialValues?.search,
          sort: defaultSortValue,
        }}
      >
        <Row gutter={[16, 8]}>
          <Col xs={24} sm={12} md={12}>
            <Form.Item label="Từ vựng tra cứu" name="search">
              <Input placeholder="Nhập từ khóa tiếng Anh..." allowClear />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={12}>
            <Form.Item label="Sắp xếp ưu tiên" name="sort">
              <Select options={SORT_OPTIONS} />
            </Form.Item>
          </Col>

          <Col xs={24} className="flex justify-end">
            <Space>
              <Button icon={<ReloadOutlined />} onClick={handleReset}>
                Đặt lại
              </Button>
              <Button type="primary" htmlType="submit" icon={<SearchOutlined />} loading={loading}>
                Tìm kiếm
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Card>
  )
}

export default AiWordSearchForm
